<template>
    <div class="Welcome">
        <article>
            <h1>Welcome to the Solar System</h1>
            <p>This 3D model shows the planets of our Solar System orbiting the Sun.</p>
            <p>While the relative distance between planets and the Sun is not accurate, the following attributes <em>are</em> accurate: <span class="link-to-disclaimer">*</span></p>
            <ul>
                <li>Sizes of planets relative to each other, and to the Sun</li>
                <li>Axial tilts</li>
                <li>Relative speeds of axial rotation</li>
                <li>Relative speeds of orbit</li>
            </ul>
            <button @click="begin">Start</button>
        </article>
        <small class="disclaimer">* If you think any of these are inaccurate, just contact me by <a href="mailto:hello@simonmclean.dev">email</a> and I'll be happy to correct.</small>
        <StarField/>
    </div>
</template>

<script>
import StarField from './StarField.vue';

export default {
    components: { StarField },
    methods: {
        begin() {
            this.$emit('beginClicked');
        },
    },
};
</script>

<style scoped>
    .Welcome {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: calc(100vh - 1rem);
        padding-left: 2rem;
        padding-right: 2rem;
    }

    article,
    .disclaimer {
        margin-top: auto;
    }

    article {
        max-width: 36rem;
        padding: 1rem 0;
    }

    h1, p, li, .disclaimer {
        line-height: 1.6em;
        letter-spacing: 0.02em;
    }

    h1 {
        font-size: 2rem;
    }

    ul {
        margin-left: 0;
        padding-left: 0;
    }

    p, li, button {
        font-size: 0.9rem;
    }

    li {
        list-style: none;
        margin-bottom: 0.5em;
    }

    li::before {
        content: "•";
        margin-right: 0.5em;
    }

    .link-to-disclaimer {
        font-size: 0.9rem;
        margin-left: 0.25em;
    }

    .disclaimer {
        font-size: 0.7rem;
        opacity: 0.8;
    }

    button {
        background-image: linear-gradient(to right, var(--blue), var(--purple));
        background-clip: padding-box;
        border: 1px solid transparent;
        border-radius: 6px;
        color: white;
        padding: 1em 3em;
        cursor: pointer;
        margin-top: 1em;
        letter-spacing: 0.05ch;
        text-transform: uppercase;
        transition: border-color 0.5s;
    }

    button:hover,
    button:focus {
        border: 1px solid var(--white);
        outline: none;
    }
</style>

